<template lang="pug">
stage-bar(:bar-class='level || "olive"', classes='small', :tags='tags', :min='min', :max='max', :value='value')
</template>

<script>
import { utils } from '../../utils'
import StageBar from './StageBar.vue'

export default {
  name: 'contract-stage-bar',
  components: { StageBar },
  props: {
    contract: null,
    title: { type: String },
    showNote: { type: Boolean, default: true },
  },
  computed: {
    level() {
      if (this.contract)
        return `expiring-level${utils.ExpiringLevel(utils.DaysToExpire(this.contract))}`
    },
    min() {
      const start = this.$moment(this.contract.date_start)
      const today = this.$moment()
      if (today < start)
        return today
      return start
    },
    max() {
      const end = this.$moment(this.contract.date_end)
      const today = this.$moment()
      if (today > end)
        return today
      return end
    },
    value() {
      return this.$moment(this.contract.date_expire || this.contract.date_start)
    },
    tags() {
      const tags = []

      tags.push({
        position: this.$moment(this.contract.date_start),
        bottom: '合同开始',
      })

      tags.push({
        position: this.$moment(this.contract.date_end),
        bottom: '合同结束',
      })

      tags.push({
        position: this.$moment(),
        top: '今天',
      })

      if (this.contract.transfer_delegated) {
        tags.push({
          position: this.$moment(this.contract.transfer_delegation.date_delegation),
          bottom: '委托开始',
        })
        tags.push({
          position: this.$moment(this.contract.transfer_delegation.date_end),
          bottom: '委托截止',
        })
      }

      if (this.contract.date_expire !== this.contract.date_end) {
        tags.push({
          position: this.$moment(this.contract.date_expire),
          bottom: '租金到期',
        })
      }

      return tags
    },
  },
}
</script>



// WEBPACK FOOTER //
// ContractStageBar.vue?7438ad30